<template>
  <v-dialog v-model="isOpen" width="800">
    <v-card>
      <v-card-title>
        {{ advance.title }}
      </v-card-title>
      <v-card-text>
        <dl>
          <dt>{{ $t('Status') }}</dt>
          <dd>{{ advance.status_display }}</dd>

          <dt>{{ $t('Business_type') }}</dt>
          <dd>{{ businessTypeLabel }}</dd>

          <dt>{{ $t('Wording') }}</dt>
          <dd>{{ advance.description }}</dd>

          <dt>{{ $t('Business_case_reason') }}</dt>
          <dd>{{ advance.reason }}</dd>

          <dt>{{ $t('Business_case_advance_creator') }}</dt>
          <dd>
            <AdvanceSignatory :signatory="advance.first_signatory" />
          </dd>

          <dt>{{ $t('Business_case_second_signature') }}</dt>
          <dd>
            <AdvanceSignatory :signatory="advance.second_signatory" />
          </dd>

          <dt>{{ $t('Business_case_third_signature') }}</dt>
          <dd>
            <AdvanceSignatory :signatory="advance.third_signatory" />
          </dd>

          <dt>{{ $t('Business_case_other_signature') }}</dt>
          <dd v-if="otherSignatories.length" data-testid="other-signatories">
            <v-row>
              <v-col col="11">
                <AdvanceSignatory
                  v-for="(signatory, index) in otherSignatories"
                  :key="`other-signatory-${signatory.type}-${signatory.id}`"
                  :signatory="signatory"
                  class="d-inline-flex align-center mr-2"
                  hide-icon
                >
                  <template #append>
                    <span v-if="index < otherSignatories.length - 1">,</span>
                  </template>
                </AdvanceSignatory>
              </v-col>
              <v-col cols="auto">
                <v-btn color="green" small rounded @click="isShowAllMembers = !isShowAllMembers">
                  <v-icon color="white" size="16">{{ isShowAllMembers ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                  <span class="ml-2 white--text">{{
                    isShowAllMembers ? $t('advanceHideCoSignerMembers') : $t('advanceShowCoSignerMembers')
                  }}</span>
                </v-btn>
              </v-col>
            </v-row>
            <VExpandTransition>
              <template v-if="isShowAllMembers">
                <v-card outlined class="mt-4">
                  <v-card-text class="member-card">
                    <div
                      v-for="(signatory, index) in getOtherSignatoriesMembers"
                      :key="`signatory-${signatory.type}-${signatory.id}`"
                    >
                      <template v-if="signatory.type === 'user'">
                        <AdvanceSignatory :signatory="signatory" />
                      </template>
                      <template v-else>
                        <AdvanceSignatory :signatory="signatory" hide-icon :class="index === 0 ? 'mb-2' : 'my-2'" />
                        <AdvanceSignatory
                          v-for="(member, member_index) in signatory.members"
                          :key="`member-${member}-${member_index}`"
                          :class="{ 'mb-2': member_index === signatory.members.length - 1 }"
                          :signatory="member"
                          :has-signed="hasMemberSigned(signatory, member)"
                          list
                        >
                          <template #item="{ item }">
                            {{ item }}
                          </template>
                        </AdvanceSignatory>
                      </template>
                    </div>
                  </v-card-text>
                </v-card>
              </template>
            </VExpandTransition>
          </dd>
          <dd v-else data-testid="other-signatories">-</dd>

          <dt>{{ $t('Business_case_rights_holder') }}</dt>
          <dd>{{ advance.rights_holder_display }}</dd>

          <dt>{{ $t('mark_urgent') }}</dt>
          <dd>
            <v-icon small :color="enabledColor(advance.is_urgent)">{{ enabledIcon(advance.is_urgent) }}</v-icon>
          </dd>

          <dt>{{ $t('Attachments') }}</dt>
          <dd>
            <ul class="pl-4">
              <li v-for="attachment in advance.attachments" :key="attachment.name">
                <a :href="attachment.url">{{ attachment.name }}</a>
              </li>
            </ul>
          </dd>
        </dl>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text @click="isOpen = false">{{ $t('Cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import get from 'lodash/get'
import isUndefined from 'lodash/isUndefined'

export default {
  name: 'AdvanceDetailDialog',
  data() {
    return {
      isOpen: false,
      advance: {},
      isShowAllMembers: false,
    }
  },
  computed: {
    otherSignatories() {
      return this.advance.other_signatories || []
    },
    getOtherSignatoriesMembers() {
      return this.advance.other_signatories || []
    },
    businessTypeLabel() {
      return get(this.advance, 'business_type.text')
    },
  },
  methods: {
    open(advance) {
      this.advance = advance
      this.isOpen = true
    },
    signatoryLabel(signatory) {
      if (isUndefined(signatory)) return ''
      if (signatory.type === 'user') return signatory.full_name
      if (signatory.type === 'committee' || signatory.type === 'committeegroup') return signatory.title || ''
      return ''
    },
    hasMemberSigned(signatory, member) {
      return (signatory.signed_members || []).includes(member)
    },
    enabledIcon(value) {
      return value ? 'mdi-check-circle' : 'mdi-close-circle'
    },
    enabledColor(value) {
      return value ? 'success' : 'error'
    },
  },
}
</script>
<style scoped>
.member-card {
  max-height: 200px;
  overflow-y: auto;
}
</style>
